/*
  获取表单验证错误信息mixin
 */
export const getErrorLabelMixin = {
  methods: {
    getErrorLabel ($field, fieldName) {
      // console.log('$field', $field);
      // console.log('fieldName', fieldName);
      // console.log('this.errorMsgs', this.errorMsgs);
      if (!$field || ({}).toString.call($field) !== '[object Object]') {
        console.error('getErrorLabel第一个参数必须是一个对象');
        return ' ';
      }
      if (typeof fieldName === 'undefined') {
        console.error('getErrorLabel第二个参数必须是一个字符串');
        return ' ';
      }
      if (!this.errorMsgs) {
        console.error('data或computed中必须有"errorMsgs"属性，并且该值须为一个对象！');
        return ' ';
      }
      if (!$field.$error) {
        return ' ';
      }
      let keys = Object.keys($field);

      fieldName = fieldName + '';
      // 获取当前字段的所有验证规则
      let validateRules = keys.filter(item => {
        return item.charAt(0) !== '$';
      });
      let fieldErrorMsg = {};
      if (!/\./.test(fieldName)) {
        fieldErrorMsg = this.errorMsgs[fieldName];
        // console.log('fieldErrorMsg 1', fieldErrorMsg);
      } else {
        let fieldNameArr = fieldName.split('.');
        fieldErrorMsg = this.errorMsgs;
        // console.log('fieldNameArr', fieldNameArr);
        fieldNameArr.forEach(item => {
          // console.log('item', item);
          fieldErrorMsg = fieldErrorMsg[item];
        });
      }
      // console.log('validateRules', validateRules);
      return validateRules.reduce((errMsg, currentRule) => {
        if (!$field[currentRule]) {
          return fieldErrorMsg[currentRule];
        }
        return errMsg;
      }, ' ');
    },
  },
};
